import { useEffect } from 'react';
import Head from 'next/head';
import SectionTitle from '@src/components/elements/SectionTitle';
import './ReviewWidgets.module.css';

const ReviewWidgets = (props) => {
  const data = props.data || props;

  useEffect(() => {
    if (typeof window !== 'undefined') {
      // Load Reviews.io script
      const reviewsScript = document.createElement('script');
      reviewsScript.src = "https://widget.reviews.io/carousel-inline-iframeless/dist.js?_t=2025080108";
      reviewsScript.async = true;
      reviewsScript.onload = () => {
        // eslint-disable-next-line no-new, new-cap, no-undef
        new carouselInlineWidget('reviewsio-carousel-widget', {
          store: 'capex-com',
          sku: '',
          lang: 'en',
          carousel_type: 'default',
          styles_carousel: 'CarouselWidget--sideHeader--withcards',
          options: {
            general: {
              review_type: 'company',
              min_reviews: '1',
              max_reviews: '20',
              address_format: 'CITY, COUNTRY',
              enable_auto_scroll: 10000,
            },
            header: {
              enable_overall_stars: true,
              rating_decimal_places: 2,
            },
            reviews: {
              enable_customer_name: true,
              enable_customer_location: true,
              enable_verified_badge: true,
              enable_subscriber_badge: true,
              enable_recommends_badge: true,
              enable_photos: true,
              enable_videos: true,
              enable_review_date: true,
              disable_same_customer: true,
              min_review_percent: 4,
              third_party_source: true,
              hide_empty_reviews: true,
              enable_product_name: true,
              tags: "",
              branch: "",
              enable_branch_name: false,
            },
            popups: {
              enable_review_popups: true,
              enable_helpful_buttons: true,
              enable_helpful_count: true,
              enable_share_buttons: true,
            },
          },
          translations: {
            verified_customer: "Verified Customer",
          },
          styles: {
            '--base-font-size': '16px',
            '--base-maxwidth': '100%',
            '--reviewsio-logo-style': 'var(--logo-inverted)',
            '--common-star-color': '#FF4848',
            '--common-star-disabled-color': 'rgba(0,0,0,0.25)',
            '--medium-star-size': '22px',
            '--small-star-size': '19px',
            '--x-small-star-size': '16px',
            '--x-small-star-display': 'inline-flex',
            '--header-order': '1',
            '--header-width': '280px',
            '--header-bg-start-color': '#161212',
            '--header-bg-end-color': '#161212',
            '--header-gradient-direction': '135deg',
            '--header-padding': '1.5em',
            '--header-border-width': '0px',
            '--header-border-color': 'rgba(0,0,0,0.1)',
            '--header-border-radius': '0px',
            '--header-shadow-size': '10px',
            '--header-shadow-color': 'rgba(0, 0, 0, 0.05)',
            '--header-star-color': '#FF4848',
            '--header-disabled-star-color': '#FF4848',
            '--header-heading-text-color': '#FF4848',
            '--header-heading-font-size': 'inherit',
            '--header-heading-font-weight': 'inherit',
            '--header-heading-line-height': 'inherit',
            '--header-heading-text-transform': 'inherit',
            '--header-subheading-text-color': '#FF4848',
            '--header-subheading-font-size': 'inherit',
            '--header-subheading-font-weight': '300',
            '--header-subheading-line-height': 'inherit',
            '--header-subheading-text-transform': 'inherit',
            '--item-maximum-columns': '5',
            '--item-background-start-color': '#ffffff',
            '--item-background-end-color': '#ffffff',
            '--item-gradient-direction': '135deg',
            '--item-padding': '1.5em',
            '--item-border-width': '0px',
            '--item-border-color': 'rgba(0,0,0,0.1)',
            '--item-border-radius': '0px',
            '--item-shadow-size': '10px',
            '--item-shadow-color': 'rgba(0,0,0,0.05)',
            '--heading-text-color': '#161212',
            '--heading-text-font-weight': '600',
            '--heading-text-font-family': '"Source Sans Pro", sans-serif',
            '--heading-text-line-height': '1.4',
            '--heading-text-letter-spacing': '0',
            '--heading-text-transform': 'none',
            '--body-text-color': '#161212',
            '--body-text-font-weight': '400',
            '--body-text-font-family': '"Source Sans Pro", sans-serif',
            '--body-text-line-height': '1.4',
            '--body-text-letter-spacing': '0',
            '--body-text-transform': 'none',
            '--scroll-button-icon-color': '#FF4848',
            '--scroll-button-icon-size': '24px',
            '--scroll-button-bg-color': '#00000000',
            '--scroll-button-border-width': '0px',
            '--scroll-button-border-color': 'rgba(0,0,0,0.1)',
            '--scroll-button-border-radius': '60px',
            '--scroll-button-shadow-size': '0px',
            '--scroll-button-shadow-color': 'rgba(0,0,0,0.1)',
            '--scroll-button-horizontal-position': '3px',
            '--scroll-button-vertical-position': '0px',
            '--badge-icon-color': '#FF4848',
            '--badge-icon-font-size': '15px',
            '--badge-text-color': '#FF4848',
            '--badge-text-font-size': 'inherit',
            '--badge-text-letter-spacing': 'inherit',
            '--badge-text-transform': 'inherit',
            '--author-font-size': 'inherit',
            '--author-font-weight': 'inherit',
            '--author-text-transform': 'inherit',
            '--photo-video-thumbnail-size': '60px',
            '--photo-video-thumbnail-border-radius': '0px',
            '--popup-backdrop-color': 'rgba(0,0,0,0.75)',
            '--popup-color': '#ffffff',
            '--popup-star-color': '#FF4848',
            '--popup-disabled-star-color': '#FF4848',
            '--popup-heading-text-color': '#FF4848',
            '--popup-body-text-color': '#FF4848',
            '--popup-badge-icon-color': '#FF4848',
            '--popup-badge-icon-font-size': '19px',
            '--popup-badge-text-color': '#FF4848',
            '--popup-badge-text-font-size': '14px',
            '--popup-border-width': '0px',
            '--popup-border-color': 'rgba(0,0,0,0.1)',
            '--popup-border-radius': '0px',
            '--popup-shadow-size': '0px',
            '--popup-shadow-color': 'rgba(0,0,0,0.1)',
            '--popup-icon-color': '#FF4848',
            '--tooltip-bg-color': '#161212',
            '--tooltip-text-color': '#FF4848',
          },
        });
      };
      document.body.appendChild(reviewsScript);
    }

    // Clean up function to prevent memory leaks
    return () => {
      // Remove any event listeners if needed
    };
  }, []);

  if (!data) return null;

  return (
    <div className='container' id={data?.section_layout?.section_id || ''}>
      <Head>
        <link rel="stylesheet" href="https://assets.reviews.io/css/widgets/carousel-widget.css?_t=2025080108" />
        <link rel="stylesheet" href="https://assets.reviews.io/iconfont/reviewsio-icons/style.css?_t=2025080108" />
      </Head>
      {
        data?.section_title &&
        <div className="w-full max-w-[95%] lg:mx-auto">
          <SectionTitle data={data?.section_title} />
        </div>
      }
      {/* Reviews.io Widget */}
      <div id="reviewsio-carousel-widget" />
    </div>
  );
};

export default ReviewWidgets;